import React from "react";
import "./index.scss";

export default function GridSection({ children, className = "", reference = null }) {
    return <section ref={reference} className={`grid-section-container ${className}`}>
        {children}
    </section>
}